import { render, staticRenderFns } from "./RestaurantCheckout.vue?vue&type=template&id=a4e78060&scoped=true&"
import script from "./RestaurantCheckout.vue?vue&type=script&lang=js&"
export * from "./RestaurantCheckout.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantCheckout.vue?vue&type=style&index=0&id=a4e78060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e78060",
  null
  
)

export default component.exports